/**
 * Shared constants for the staging area UI.
 * Maps display field names (from the backend diff DTO) to backend merge request keys.
 */

/** Voyage diff field display name → backend SelectiveMergeRequest field key */
export const FIELD_NAME_TO_KEY = {
  'Voyage Number': 'voyageNumber',
  'Ship (IMO)': 'imo',
  'Departure Port': 'departurePort',
  'Destination Port': 'destinationPort',
  'Actual ETD': 'actualETD',
  'Actual ETA': 'actualETA',
  Cancelled: 'cancelled',
  'Slot Confirmed': 'slotConfirmed',
  'General Remarks': 'generalRemarks',
};

/** Shipment diff field display name → backend ShipmentMergeInstruction field key */
export const SHIPMENT_FIELD_NAME_TO_KEY = {
  'Effective Shipped': 'effectiveShipped',
  'Final Agreement': 'finalAgreement',
  'First Shipping Line Offer': 'firstShippingLineOffer',
  'Adjusted PO Request': 'adjustedPORequest',
};

/** Confidence score color thresholds */
export const confidenceColor = (confidence) => {
  if (confidence >= 0.8) return 'success';
  if (confidence >= 0.5) return 'warning';
  return 'default';
};
